var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Http, ConnectionBackend, RequestOptions, Response, RequestMethod, ResponseOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { _throw } from 'rxjs/observable/throw';
import { catchError } from 'rxjs/operators';
import { extend } from 'lodash';
import { environment } from '@env/environment';
import { Logger } from '../logger.service';
import { HttpCacheService } from './http-cache.service';
import { HttpCachePolicy } from './request-options-args';
var log = new Logger('HttpService');
/**
 * Provides a base framework for http service extension.
 * The default extension adds support for API prefixing, request caching and default error handler.
 */
var HttpService = /** @class */ (function (_super) {
    __extends(HttpService, _super);
    function HttpService(backend, defaultOptions, httpCacheService) {
        var _this = 
        // Customize default options here if needed
        _super.call(this, backend, defaultOptions) || this;
        _this.defaultOptions = defaultOptions;
        _this.httpCacheService = httpCacheService;
        return _this;
    }
    /**
     * Performs any type of http request.
     * You can customize this method with your own extended behavior.
     */
    HttpService.prototype.request = function (request, options) {
        var _this = this;
        var requestOptions = options || {};
        var url;
        if (typeof request === 'string') {
            url = request;
            request = url; //environment.serverUrl + url;
        }
        else {
            url = request.url;
            request.url = url; // environment.serverUrl + url;
        }
        if (!requestOptions.cache) {
            // Do not use cache
            return this.httpRequest(request, requestOptions);
        }
        else {
            return new Observable(function (subscriber) {
                var cachedData = requestOptions.cache === HttpCachePolicy.Update ?
                    null : _this.httpCacheService.getCacheData(url);
                if (cachedData !== null) {
                    // Create new response to avoid side-effects
                    subscriber.next(new Response(cachedData));
                    subscriber.complete();
                }
                else {
                    _this.httpRequest(request, requestOptions).subscribe(function (response) {
                        // Store the serializable version of the response
                        _this.httpCacheService.setCacheData(url, null, new ResponseOptions({
                            body: response.text(),
                            status: response.status,
                            headers: response.headers,
                            statusText: response.statusText,
                            type: response.type,
                            url: response.url
                        }));
                        subscriber.next(response);
                    }, function (error) { return subscriber.error(error); }, function () { return subscriber.complete(); });
                }
            });
        }
    };
    HttpService.prototype.get = function (url, options) {
        return this.request(url, extend({}, options, { method: RequestMethod.Get }));
    };
    HttpService.prototype.post = function (url, body, options) {
        return this.request(url, extend({}, options, {
            body: body,
            method: RequestMethod.Post
        }));
    };
    HttpService.prototype.put = function (url, body, options) {
        return this.request(url, extend({}, options, {
            body: body,
            method: RequestMethod.Put
        }));
    };
    HttpService.prototype.delete = function (url, options) {
        return this.request(url, extend({}, options, { method: RequestMethod.Delete }));
    };
    HttpService.prototype.patch = function (url, body, options) {
        return this.request(url, extend({}, options, {
            body: body,
            method: RequestMethod.Patch
        }));
    };
    HttpService.prototype.head = function (url, options) {
        return this.request(url, extend({}, options, { method: RequestMethod.Head }));
    };
    HttpService.prototype.options = function (url, options) {
        return this.request(url, extend({}, options, { method: RequestMethod.Options }));
    };
    // Customize the default behavior for all http requests here if needed
    HttpService.prototype.httpRequest = function (request, options) {
        var _this = this;
        var req = _super.prototype.request.call(this, request, options);
        if (!options.skipErrorHandler) {
            req = req.pipe(catchError(function (error) { return _this.errorHandler(error); }));
        }
        return req;
    };
    // Customize the default error handler here if needed
    HttpService.prototype.errorHandler = function (response) {
        if (environment.production) {
            // Avoid unchaught exceptions on production
            log.error('Request error', response);
            return _throw(response);
        }
        throw response;
    };
    return HttpService;
}(Http));
export { HttpService };



// WEBPACK FOOTER //
// ./src/app/core/http/http.service.ts.pre-build-optimizer.js